<template>
  <div class="mb-5" v-if="facility">
    <div class="text-h5 font-weight-bold my-4">Facility Details</div>
    <v-card>
      <v-layout class="px-2 pb-3" justify-space-between>
        <v-flex xs4>
          <v-card-title class="text-h6">Basic Information</v-card-title>
          <v-divider class="mx-2" />
          <v-card-text class="subheading">
            <v-layout>
              <v-flex xs5>Location Code: </v-flex>
              <v-flex xs7 data-testid="location-code">{{ facility.location_code }}</v-flex>
            </v-layout>
            <v-layout>
              <v-flex class="pb-0" xs5>Address: </v-flex>
              <v-flex
                class="pb-0"
                xs7
                data-testid="street-address-one"
              >
                {{ facility.street_address }}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                class="pt-0"
                xs5
              />
              <v-flex
                class="pt-0"
                xs7
                data-testid="street-address-two"
              >
                {{ facility.city }}, {{ facility.state }} {{ facility.postal_code }}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5>Phone:</v-flex>
              <v-flex xs7 data-testid="facility-phone">{{ facility.phone }}</v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5>Contact E-mail:</v-flex>
              <v-flex data-testid="contact-email" xs7>{{ facility.contact_email }}</v-flex>
            </v-layout>
            <v-layout v-if="facility.contact_email_cc">
              <v-flex xs5>Contact E-mail CC:</v-flex>
              <v-flex xs7 data-testid="contact-email-cc">{{ facility.contact_email_cc }}</v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5>Price Range:</v-flex>
              <v-flex xs7 data-testid="price-range">
                ${{ facility.min_unit_price }} - ${{ facility.max_unit_price }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-flex>
        <v-flex xs4>
          <v-card-title class="text-h6">Office Hours</v-card-title>
          <v-divider class="mx-2" />
          <v-card-text
            class="subheading"
            v-for="(hours, day) in facility.external_office_hours"
            :key="hours.i"
          >
            <v-layout>
              <v-flex
                class="pb-0"
                xs4
                data-testid="office-hours-day"
                :style="'text-transform: capitalize'"
              >
                {{ day }}:
              </v-flex>
              <v-flex class="pb-0" data-testid="office-hours-range">
                <span v-if="hours.open == hours.close">Open 24 Hours</span>
                <span v-else>{{ hours.open }} - {{ hours.close }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-flex>
        <v-flex xs4>
          <v-card-title class="text-h6">Access Hours</v-card-title>
          <v-divider class="mx-2" />
          <v-card-text
            class="subheading"
            v-for="(hours, day) in facility.external_access_hours"
            :key="hours.i"
          >
            <v-layout>
              <v-flex
                class="pb-0"
                xs4
                :style="'text-transform: capitalize'"
                data-testid="access-hours-day"
              >
                {{ day }}:
              </v-flex>
              <v-flex class="pb-0" data-testid="office-hours-range">
                <span data-testid="access-hours-range" v-if="hours.open == hours.close">24 hour access</span>
                <span data-testid="access-hours-range" v-else>{{ hours.open }} - {{ hours.close }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AdminInfo",
  computed: {
    facility() {
      return this.$store.state.facilities.facility;
    }
  }
};
</script>
